import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, List, Paper, Stack, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { MealPatternNameKind } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

import MealPatternItem from "./MealPatternItem";

interface Props {
  className?: string;
  onClose: () => void;
  onAddMealPattern: (name: MealPatternNameKind, amountServings: number) => void;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: 0,
    padding: theme.spacing(4, 3),
  },
  title: {
    fontSize: 18,
    lineHeight: 1,
    fontWeight: 700,
    color: colors.dark,
  },
  closeButton: {
    padding: theme.spacing(1),
    color: colors.grey,
    backgroundColor: "#E8EEF6",
  },
  list: {
    maxHeight: "calc(100vh - 290px)",
    overflow: "auto",
  },
}));

const MealPatternDatabase: React.FC<Props> = ({
  className,
  onClose,
  onAddMealPattern,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Paper className={cx(classes.root, className)} elevation={0}>
      <Stack spacing={4}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className={classes.title}>Select Items</Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Stack>
          <List className={classes.list}>
            {Object.values(MealPatternNameKind).map((name) => (
              <MealPatternItem
                key={name}
                name={name}
                onAddMealPattern={onAddMealPattern}
              />
            ))}
          </List>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default MealPatternDatabase;
